/* eslint-disable */
jQuery(function($){
  if(navigator.userAgent.match(/Trident\/7\./)) {
    //ie11の時の処理
    if($('.c-grid__wrapper').length) {
      $('.c-grid__wrapper').each(function () {
        $(this).wrapInner('<div class="c-grid__inner" />');
      });
      $('.c-grid').each(function (){
        $(this).after('<div class="c-grid__margin" />');
      });
    }

    if($('.c-title--level1').length) {
      $('.c-title--level1').each(function(){
        $(this).wrap('<div class="c-title--level1__wrap" />')
      });
    }
  }

// 一個しか開かないドロップダウン
  if($('[data-accordionone="el"]').length) {
    $('[data-accordionone="el"]').each(function () {
      if($(this).children('[data-dropdownone="head"]').data('open')) {
        let maxheight = $(this).children('[data-dropdownone="body"]').get(0).scrollHeight;
        $(this).addClass('is-open').children('[data-dropdownone="body"]').css('max-height', maxheight);
      }
      $(this).children('[data-dropdownone="head"]').on('click', function(){
        let maxheight = $(this).next('[data-dropdownone="body"]').get(0).scrollHeight;
        let openf = $(this).parent('[data-accordionone="el"]').hasClass('is-open');

        if(openf) {
          $(this).next('[data-dropdownone="body"]').css('max-height', 0).parent('[data-accordionone="el"]').removeClass('is-open');
        } else {
          $(this).next('[data-dropdownone="body"]').css('max-height', maxheight).parent('[data-accordionone="el"]').addClass('is-open').siblings('[data-accordionone="el"].is-open').removeClass('is-open').children('[data-dropdownone="body"]').css('max-height', 0);
        }
      });
    });
  }
});
